// mparle-card-add.js
// Add-to-cart knop op product-cards (collectie, bestsellers, recommendations, etc).
// Alleen actief op cards met exact één variant — bij meerdere variants is de knop
// een gewone <a> naar de PDP en komt deze handler niet aan bod.
//
// Na succesvolle /cart/add.js dispatcht deze module een 'mp:cart:refresh-and-open'
// event dat mparle-cart-drawer.js opvangt om de drawer opnieuw te renderen + openen.
(function () {
  let busy = false;

  async function addToCart(btn) {
    if (busy) return;
    const variantId = btn.dataset.mpCardAdd;
    if (!variantId) return;
    busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) {
        console.error('card add failed', await res.json().catch(() => ({})));
        return;
      }
      document.dispatchEvent(new CustomEvent('mp:cart:refresh-and-open'));
      btn.classList.add('is-success');
      setTimeout(() => btn.classList.remove('is-success'), 900);
    } catch (err) {
      console.error('card add error', err);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      busy = false;
    }
  }

  // Event-delegatie zodat ook nieuw-geappende cards (load-more) meteen werken.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mp-card-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();
